/* @flow */

import MissingDocNote from "app/users/subscription/tab3/missingdocdialog/model";

export default class setMissingDocumentsNotesRequest {
  companyId: number;
  missingDocumentsNotes: MissingDocNote[];
}
